import React, { Component } from "react";
import "./BrandContent.scss";
import { getBrandById } from "../../../../api/brands";
import { getProductsByBrand } from "../../../../api/brands";
import images from "../../../../ressources/images";
import BrandProductsItem from "../../../../components/Brands/BrandProductsItem/BrandProductsItem";
import { withTranslation } from "react-i18next";

export class BrandProduits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      whoActive: "produits",
      idFormation: 0,
      dataBrand: [],
      dataProductByBrand: [],
      lng: this.props.i18n.language,
      loadImage: false,
    };
  }

  UNSAFE_componentWillMount() {
    let brandId = document.location.href.split("/");
    brandId = brandId[brandId.length - 1];
    this.setState({ idFormation: brandId });
  }

  componentDidMount() {
    this.getBrandByIdFront();
    this.getBrandByProductFront();
  }

  componentDidUpdate() {
    if (this.state.lng !== this.props.i18n.language) {
      this.setState({ lng: this.props.i18n.language });
      this.getBrandByIdFront();
      this.getBrandByProductFront();
    }
  }

  getBrandByIdFront = () => {
    const { idFormation } = this.state;
    this.setState({ dataBrand: [] });
    getBrandById(idFormation).then((data) => {
      this.setState({ dataBrand: data, loadImage: true });
    });
  };

  getBrandByProductFront = () => {
    const { idFormation } = this.state;
    this.setState({ dataProductByBrand: [] });
    getProductsByBrand(idFormation).then((data) => {
      this.setState({ dataProductByBrand: data });
    });
  };

  _goBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  render() {
    const { t } = this.props;
    const { dataBrand, dataProductByBrand, loadImage } = this.state;
    return (
      <>
        <div className="white--wrapper">
          <div className="brandlist_backlink" onClick={this._goBack}>
            <img src={images.arrow_left_black} alt="" />
          </div>
          <div className="brandlist_content default-layout--min-height flex flex-col">
            <div className="flex-row-center">
              <div className="brand_logo">
                {loadImage && (
                  <img
                    className="brandlist_logo"
                    src={dataBrand.logoNoir}
                    alt="logo"
                  />
                )}
              </div>
            </div>
            <div className="brand_contentlist brand_productlist">
              {dataProductByBrand.length > 0 ? (
                dataProductByBrand.map((data) => (
                  <BrandProductsItem
                    key={data.id}
                    title={data.name}
                    img={data.picture}
                    pdf={data.file}
                    link={data.link}
                  />
                ))
              ) : (
                <div className="back_soon">
                  <div>{t("stock_missing")}</div>
                  <div>{t("come_back_soon")} </div>
                  <span className="smile" role="img" aria-label="">
                    &#128578;
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(BrandProduits);
